import React from 'react';

import Contacts from '@totem/components/settings/sections/contacts/contacts';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

const ContactsPage = () => {
  return (
    <ContentLayout>
      <Contacts />
    </ContentLayout>
  );
};

export default ContactsPage;
